export default {
  getPlaylist: {},
  getAllPlaylist: {},
  getCategory: {},
  getAllCategory: {},
  getEpisode: {},
  getAllEpisode: {},
  selectedPlaylist: {},
  selectedCategory: {},
  selectedEpisode: {},
  getAllHistory: {},
  getAllForm: {},
};
